import { Component } from '@angular/core';
import { BaseDetailPageComponent } from '../../../../components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from '../../../../models/base-detail-page.config';
import { ItemProductsService } from '../../../../services/api/general-settings/item-products.service';
import { RouteService } from '../../../../services/route.service';

@Component({
  selector: 'app-item-products-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './item-products-detail-page.component.html',
  styleUrl: './item-products-detail-page.component.scss'
})
export class ItemProductsDetailPageComponent {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail: boolean

  ItemProduct?: any;

  constructor(
    private itemProductsService: ItemProductsService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Item Types',
      cardTitle: 'Item Types Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Item Product',
        onClick: () => {
          this.routeService.itemProductsUpdate(this.ItemProduct.id)
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
        ]
      },
      apiDetailService: (ItemProductId: number) => this.itemProductsService.detail(ItemProductId),
      routeParamName: 'itemProductId',
      responseModelName: 'itemProduct'
    };

  }

  onLoadedDetail(data: any) {
    this.ItemProduct = data;
  }
}
